/* tslint:disable */
/* eslint-disable */
/**
 * channels-com
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
  BodyAddCartItemCartsItemPost,
  BodyAddCartItemCartsItemPostFromJSON,
  BodyAddCartItemCartsItemPostToJSON,
  BodyUpdateCartItemCartsItemPut,
  BodyUpdateCartItemCartsItemPutFromJSON,
  BodyUpdateCartItemCartsItemPutToJSON,
  CartItemResponse,
  CartItemResponseFromJSON,
  CartItemResponseToJSON,
  CartResponse,
  CartResponseFromJSON,
  CartResponseToJSON,
  HTTPValidationError,
  HTTPValidationErrorFromJSON,
  HTTPValidationErrorToJSON,
  OrderCartResponse,
  OrderCartResponseFromJSON,
  OrderCartResponseToJSON,
} from '../models';

export interface AddCartItemCartsItemPostRequest {
  bodyAddCartItemCartsItemPost: BodyAddCartItemCartsItemPost;
  acceptLanguage?: string;
}

export interface GetCartCartsGetRequest {
  acceptLanguage?: string;
}

export interface OrderCartCartsOrderPostRequest {
  acceptLanguage?: string;
}

export interface RemoveCartItemCartsItemIdDeleteRequest {
  id: number;
  acceptLanguage?: string;
}

export interface UpdateCartItemCartsItemPutRequest {
  bodyUpdateCartItemCartsItemPut: BodyUpdateCartItemCartsItemPut;
  acceptLanguage?: string;
}

/**
 *
 */
export class CartsApi extends runtime.BaseAPI {
  /**
   *    This endpoint is used to add an item to the cart.     it will do three checks before adding the item:    - checks if the user has an active cart, if not it will create a cart.    - checks from the availability of the quantity for the channel,     if it is not available an Error Exception will be raised.    - finally, adds the item if it doesn\'t exist in the cart, otherwise just update the quantity of the item.     It has the following header parameter:    - **accept-language**: optional to be set (either \"ar\" Arabic or \"en\" English)     and body request contains the following attributes:    - **id**: denomination id.    - **quantity**: the number of items to be purchased.
   * Add Cart Item
   */
  async addCartItemCartsItemPostRaw(
    requestParameters: AddCartItemCartsItemPostRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<CartItemResponse>> {
    if (
      requestParameters.bodyAddCartItemCartsItemPost === null ||
      requestParameters.bodyAddCartItemCartsItemPost === undefined
    ) {
      throw new runtime.RequiredError(
        'bodyAddCartItemCartsItemPost',
        'Required parameter requestParameters.bodyAddCartItemCartsItemPost was null or undefined when calling addCartItemCartsItemPost.'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (
      requestParameters.acceptLanguage !== undefined &&
      requestParameters.acceptLanguage !== null
    ) {
      headerParameters['accept-language'] = String(
        requestParameters.acceptLanguage
      );
    }

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('HTTPBearer', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/carts/item`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: BodyAddCartItemCartsItemPostToJSON(
          requestParameters.bodyAddCartItemCartsItemPost
        ),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CartItemResponseFromJSON(jsonValue)
    );
  }

  /**
   *    This endpoint is used to add an item to the cart.     it will do three checks before adding the item:    - checks if the user has an active cart, if not it will create a cart.    - checks from the availability of the quantity for the channel,     if it is not available an Error Exception will be raised.    - finally, adds the item if it doesn\'t exist in the cart, otherwise just update the quantity of the item.     It has the following header parameter:    - **accept-language**: optional to be set (either \"ar\" Arabic or \"en\" English)     and body request contains the following attributes:    - **id**: denomination id.    - **quantity**: the number of items to be purchased.
   * Add Cart Item
   */
  async addCartItemCartsItemPost(
    requestParameters: AddCartItemCartsItemPostRequest,
    initOverrides?: RequestInit
  ): Promise<CartItemResponse> {
    const response = await this.addCartItemCartsItemPostRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   *    This endpoint is used to retrieve cart information for a user on the checkout page (channels STORE).     it will check first if the user has a crat, if not it will create a cart for the user.     It has the following header parameter:    - **accept-language**: optional to be set (either \"ar\"A rabic or \"en\" English)
   * Get Cart
   */
  async getCartCartsGetRaw(
    requestParameters: GetCartCartsGetRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<CartResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      requestParameters.acceptLanguage !== undefined &&
      requestParameters.acceptLanguage !== null
    ) {
      headerParameters['accept-language'] = String(
        requestParameters.acceptLanguage
      );
    }

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('HTTPBearer', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/carts/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CartResponseFromJSON(jsonValue)
    );
  }

  /**
   *    This endpoint is used to retrieve cart information for a user on the checkout page (channels STORE).     it will check first if the user has a crat, if not it will create a cart for the user.     It has the following header parameter:    - **accept-language**: optional to be set (either \"ar\"A rabic or \"en\" English)
   * Get Cart
   */
  async getCartCartsGet(
    requestParameters: GetCartCartsGetRequest,
    initOverrides?: RequestInit
  ): Promise<CartResponse> {
    const response = await this.getCartCartsGetRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   *    This endpoint is used to proceed with the order for a cart.     it will check:    - if the channel is active,    if not an Error Exception will be raised.    - if the cart is active,    if there is no existing cart or no items are existing an Error Exception will be raised.    - if the total is less than or equal to zero, an Error Exception will be raised.    - if the balance is not enough, an Error Exception will be raised.    - if the quantity is not available, an Error Exception will be raised.     if the above steps went smoothly:    - creates order request with order microservice.    - deactivates cart.    - completes order request with order microservice.    - sends an email to the user if the balance has ended.    - updates the balance with the new one in the channel table.    - sends an alert email if the balance reaches the minimum value.     It has the following header parameter:    - **accept-language**: optional to be set (either \"ar\" Arabic or \"en\" English).
   * Order Cart
   */
  async orderCartCartsOrderPostRaw(
    requestParameters: OrderCartCartsOrderPostRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<OrderCartResponse>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      requestParameters.acceptLanguage !== undefined &&
      requestParameters.acceptLanguage !== null
    ) {
      headerParameters['accept-language'] = String(
        requestParameters.acceptLanguage
      );
    }

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('HTTPBearer', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/carts/order`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      OrderCartResponseFromJSON(jsonValue)
    );
  }

  /**
   *    This endpoint is used to proceed with the order for a cart.     it will check:    - if the channel is active,    if not an Error Exception will be raised.    - if the cart is active,    if there is no existing cart or no items are existing an Error Exception will be raised.    - if the total is less than or equal to zero, an Error Exception will be raised.    - if the balance is not enough, an Error Exception will be raised.    - if the quantity is not available, an Error Exception will be raised.     if the above steps went smoothly:    - creates order request with order microservice.    - deactivates cart.    - completes order request with order microservice.    - sends an email to the user if the balance has ended.    - updates the balance with the new one in the channel table.    - sends an alert email if the balance reaches the minimum value.     It has the following header parameter:    - **accept-language**: optional to be set (either \"ar\" Arabic or \"en\" English).
   * Order Cart
   */
  async orderCartCartsOrderPost(
    requestParameters: OrderCartCartsOrderPostRequest,
    initOverrides?: RequestInit
  ): Promise<OrderCartResponse> {
    const response = await this.orderCartCartsOrderPostRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   *    This endpoint is used to delete an item from the cart.     it will check if the item belongs to the channel of the user,     if not an Error Exception will be raised.     otherwise, the process will be done successfully.     It has one path parameter:    - **id**: cartitem id, it is required.     and one header parameter:    - **accept-language**: optional to be set (either \"ar\" Arabic or \"en\" English).
   * Remove Cart Item
   */
  async removeCartItemCartsItemIdDeleteRaw(
    requestParameters: RemoveCartItemCartsItemIdDeleteRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<CartItemResponse>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling removeCartItemCartsItemIdDelete.'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (
      requestParameters.acceptLanguage !== undefined &&
      requestParameters.acceptLanguage !== null
    ) {
      headerParameters['accept-language'] = String(
        requestParameters.acceptLanguage
      );
    }

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('HTTPBearer', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/carts/item/{id}`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters.id))
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CartItemResponseFromJSON(jsonValue)
    );
  }

  /**
   *    This endpoint is used to delete an item from the cart.     it will check if the item belongs to the channel of the user,     if not an Error Exception will be raised.     otherwise, the process will be done successfully.     It has one path parameter:    - **id**: cartitem id, it is required.     and one header parameter:    - **accept-language**: optional to be set (either \"ar\" Arabic or \"en\" English).
   * Remove Cart Item
   */
  async removeCartItemCartsItemIdDelete(
    requestParameters: RemoveCartItemCartsItemIdDeleteRequest,
    initOverrides?: RequestInit
  ): Promise<CartItemResponse> {
    const response = await this.removeCartItemCartsItemIdDeleteRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   *    This endpoint is used to update the cart with a new item.     it will check:    - if the item belongs to the channel of the user,      if not an Error Exception will be raised.     - if the sending quantity is less than or equal to zero, an Error Exception will be raised.     otherwise, the process will be done successfully.     it has body request contains the following attributes:    - **id**: cartitem id.    - **quantity**: the number of items to be purchased.     and a header parameter:    - **accept-language**: optional to be set (either \"ar\"A rabic or \"en\" English).
   * Update Cart Item
   */
  async updateCartItemCartsItemPutRaw(
    requestParameters: UpdateCartItemCartsItemPutRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<CartItemResponse>> {
    if (
      requestParameters.bodyUpdateCartItemCartsItemPut === null ||
      requestParameters.bodyUpdateCartItemCartsItemPut === undefined
    ) {
      throw new runtime.RequiredError(
        'bodyUpdateCartItemCartsItemPut',
        'Required parameter requestParameters.bodyUpdateCartItemCartsItemPut was null or undefined when calling updateCartItemCartsItemPut.'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (
      requestParameters.acceptLanguage !== undefined &&
      requestParameters.acceptLanguage !== null
    ) {
      headerParameters['accept-language'] = String(
        requestParameters.acceptLanguage
      );
    }

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('HTTPBearer', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/carts/item`,
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: BodyUpdateCartItemCartsItemPutToJSON(
          requestParameters.bodyUpdateCartItemCartsItemPut
        ),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CartItemResponseFromJSON(jsonValue)
    );
  }

  /**
   *    This endpoint is used to update the cart with a new item.     it will check:    - if the item belongs to the channel of the user,      if not an Error Exception will be raised.     - if the sending quantity is less than or equal to zero, an Error Exception will be raised.     otherwise, the process will be done successfully.     it has body request contains the following attributes:    - **id**: cartitem id.    - **quantity**: the number of items to be purchased.     and a header parameter:    - **accept-language**: optional to be set (either \"ar\"A rabic or \"en\" English).
   * Update Cart Item
   */
  async updateCartItemCartsItemPut(
    requestParameters: UpdateCartItemCartsItemPutRequest,
    initOverrides?: RequestInit
  ): Promise<CartItemResponse> {
    const response = await this.updateCartItemCartsItemPutRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }
}
